import CommendapediaEntry from '@commenda/cms/components/view-markdown';

function FilingCommendapedia({ commendapediaId }: { commendapediaId: number }) {
  return (
    <CommendapediaEntry
      entryId={commendapediaId}
      token={process.env.NEXT_PUBLIC_STRAPI_READ_TOKEN}
      renderers={{
        h1: ({ children }) => (
          <h1 className="text-base pt-0 font-bold text-black first-of-type:pb-4 py-2 px-6 first-of-type:border-b">
            {children as React.ReactNode}
          </h1>
        ),
        h2: ({ children }) => (
          <h2 className="text-base font-bold text-black py-3 px-6">
            {children as React.ReactNode}
          </h2>
        ),
        h3: ({ children }) => (
          <h3 className="text-base font-bold text-black py-3 px-6">
            {children as React.ReactNode}
          </h3>
        ),
        p: ({ children }) => (
          <p className="body-15-regular px-6 py-2">
            {children as React.ReactNode}
          </p>
        ),
        strong: ({ children }) => (
          <span className="font-semibold">{children as React.ReactNode}</span>
        ),
        li: ({ children }) => (
          <li className="body-15-regular pb-4 [&_ul]:mt-3">
            {children as React.ReactNode}
          </li>
        ),
        ul: ({ children }) => (
          <ul className="px-12 list-disc">{children as React.ReactNode}</ul>
        ),
        ol: ({ children }) => (
          <ol className="px-6">{children as React.ReactNode}</ol>
        ),
      }}
    />
  );
}

export { FilingCommendapedia };
